<div class="row">
  @if (fields().includes('firstName')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.firstName'">{{
            'serviceData.form.firstName' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="firstName"
            appInputValidationStatus
            [id]="idPrefix() + '.firstName'"
            [attr.data-cy]="idPrefix() + '-FirstName-input'"
            [placeholder]="
              'serviceData.form.placeholders.firstName' | translate
            "
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="firstName"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('lastName')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.lastName'">{{
            'serviceData.form.lastName' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="lastName"
            appInputValidationStatus
            [id]="idPrefix() + '.lastName'"
            [attr.data-cy]="idPrefix() + '-LastName-input'"
            [placeholder]="'serviceData.form.placeholders.lastName' | translate"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="lastName"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('dateOfBirth')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.dateOfBirth'">{{
            'serviceData.form.dateOfBirth' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            ngbDatepicker
            class="form-control"
            formControlName="dateOfBirth"
            appInputValidationStatus
            container="body"
            #dateOfBirthDatepicker="ngbDatepicker"
            [id]="idPrefix() + '.dateOfBirth'"
            [attr.data-cy]="idPrefix() + '-DateOfBirth-input'"
            [minDate]="momentToNgbDate(minDate)"
            [maxDate]="maxDate()"
            [startDate]="momentToNgbDate(birthdayStartDate)"
            [placeholder]="
              'serviceData.form.placeholders.dateFormat' | translate
            "
            (click)="dateOfBirthDatepicker.toggle()"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          @let dateOfBirthControl = form.get('dateOfBirth');
          @if (
            minAge() > 0 &&
            dateOfBirthControl.errors?.ngbDate?.maxDate &&
            (dateOfBirthControl.dirty || dateOfBirthControl.touched)
          ) {
            <div class="pt-1 pb-2">
              <span class="text-danger caption">
                {{ 'validation.dateOfBirth.maxDate' | translate }}
              </span>
            </div>
          } @else {
            <app-validation-error
              for="dateOfBirth"
              translations="validation.generic"
            />
          }
        </div>
      </div>
    </div>
  }
  @if (fields().includes('email')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.email'">{{
            'serviceData.form.email' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="email"
            appInputValidationStatus
            [id]="idPrefix() + '.email'"
            [attr.data-cy]="idPrefix() + '-Email-input'"
            [placeholder]="'serviceData.form.placeholders.email' | translate"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error for="email" translations="validation.generic" />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('documentNumber')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.documentNumber'">{{
            'serviceData.form.documentNumber' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="documentNumber"
            appInputValidationStatus
            [id]="idPrefix() + '.documentNumber'"
            [attr.data-cy]="idPrefix() + '-DocumentNumber-input'"
            [placeholder]="
              'serviceData.form.placeholders.documentNumber' | translate
            "
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="documentNumber"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('phoneNumber')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.phoneNumber'">{{
            'serviceData.form.phoneNumber' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="phoneNumber"
            appInputValidationStatus
            [id]="idPrefix() + '.phoneNumber'"
            [attr.data-cy]="idPrefix() + '-PhoneNumber-input'"
            [placeholder]="
              'serviceData.form.placeholders.phoneNumber' | translate
            "
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="phoneNumber"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('gender')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label>{{
            'serviceData.form.participants.gender' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          @for (gender of [Gender.Male, Gender.Female]; track gender) {
            <div class="form-check form-check-inline form-check-lg">
              <input
                class="form-check-input me-2"
                type="radio"
                formControlName="gender"
                [id]="idPrefix() + '.gender' + gender"
                [attr.data-cy]="idPrefix() + '-Gender-radio-' + gender"
                [value]="gender"
              />
              <label
                class="form-check-label"
                [for]="idPrefix() + '.gender' + gender"
              >
                {{ 'serviceData.gender.' + gender | translate }}
              </label>
            </div>
          }
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="gender"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('relationship')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.relationship'">{{
            'serviceData.form.participants.relationship' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <app-select
            class="w-100"
            formControlName="relationship"
            [id]="idPrefix() + '.relationship'"
            [attr.data-cy]="idPrefix() + '-Relationship-select'"
            [placeholder]="
              'serviceData.form.participants.relationshipPlaceholder'
                | translate
            "
          >
            @for (relationship of relationships; track relationship) {
              <app-select-option
                [value]="relationship"
                [label]="'serviceData.relationship.' + relationship | translate"
              />
            }
          </app-select>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="relationship"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
  }
  @if (fields().includes('ethnicity')) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label [for]="idPrefix() + '.ethnicity'">{{
            'serviceData.form.ethnicity' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <app-select
            class="w-100"
            formControlName="ethnicitySelect"
            [id]="idPrefix() + '.ethnicity'"
            [attr.data-cy]="idPrefix() + '-Ethnicity-select'"
            [placeholder]="
              'serviceData.form.placeholders.ethnicity' | translate
            "
          >
            @for (ethnicity of ethnicities; track ethnicity) {
              <app-select-option
                [value]="ethnicity"
                [label]="'serviceData.ethnicity.' + ethnicity | translate"
              />
            }
          </app-select>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="ethnicity"
            translations="validation.generic"
          />
        </div>
      </div>
    </div>
    @if (showEthnicityInput()) {
      <div class="col-12 col-md-6 mb-3">
        <input
          class="form-control"
          formControlName="ethnicity"
          appInputValidationStatus
          [attr.data-cy]="idPrefix() + '-EthnicityDescription-input'"
          [placeholder]="'serviceData.form.placeholders.ethnicity' | translate"
        />
        <app-validation-error
          for="ethnicity"
          translations="validation.generic"
        />
      </div>
    }
  }
</div>
